"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBlockButton = exports.connectCreateBlockButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CreateButton_1 = __importDefault(require("CommonUI/CreateButton/CreateButton"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var AddBlockMenu_1 = require("../AddBlockMenu/AddBlockMenu");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var ContentSidebarViewStore_1 = require("Project/ContentSidebar/ContentSidebarViewStore");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var AddBlockMenuPositioning_1 = require("../AddBlockMenu/AddBlockMenuPositioning");
var v1_1 = __importDefault(require("uuid/v1"));
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var utils_2 = require("@qwilr/kaleidoscope/utils");
var react_dom_1 = __importDefault(require("react-dom"));
var ContentSidebarLibraryViewStore_1 = require("Project/ContentSidebar/Library/ContentSidebarLibraryViewStore");
var connectCreateBlockButton = function (usingFeature, contentSidebarViewStore, contentSidebarLibraryViewStore, dropzonesStore, hasBlockType) {
    var sidebarEnabled = usingFeature(FeatureFlag_1.default.Sidebar);
    var disabledCreateOptions = [];
    if (!usingFeature(FeatureFlag_1.default.Accept)) {
        disabledCreateOptions.push(BlockTypes_1.BlockType.Accept);
    }
    if (!usingFeature(FeatureFlag_1.default.Quote)) {
        disabledCreateOptions.push(BlockTypes_1.BlockType.Quote);
        disabledCreateOptions.push(BlockTypes_1.BlockType.OldQuote);
    }
    return function (_a) {
        var onClick = _a.onClick, isJustBelowFirstBlock = _a.isJustBelowFirstBlock, onAddBlock = _a.onAddBlock, getCreateBlockButtonIndex = _a.getCreateBlockButtonIndex;
        return (react_1.default.createElement(CreateBlockButton, { isJustBelowFirstBlock: isJustBelowFirstBlock, onClick: function () {
                if (!sidebarEnabled) {
                    onClick();
                }
            }, sidebarEnabled: sidebarEnabled, contentSidebarViewStore: contentSidebarViewStore, contentSidebarLibraryViewStore: contentSidebarLibraryViewStore, onAddBlock: onAddBlock, disabledCreateOptions: disabledCreateOptions, dropzonesStore: dropzonesStore, getCreateBlockButtonIndex: getCreateBlockButtonIndex, hasBlockType: hasBlockType }));
    };
};
exports.connectCreateBlockButton = connectCreateBlockButton;
var CreateBlockButton = (function (_super) {
    __extends(CreateBlockButton, _super);
    function CreateBlockButton(props) {
        var _this = _super.call(this, props) || this;
        _this.addMenuOpen = false;
        _this.createBlockButtonRef = react_1.default.createRef();
        _this.handleClick = function () {
            var _a = _this.props, sidebarEnabled = _a.sidebarEnabled, contentSidebarViewStore = _a.contentSidebarViewStore, onClick = _a.onClick;
            if (sidebarEnabled) {
                if (_this.showCloseIcon) {
                    if (_this.isDropzoneOpen) {
                        contentSidebarViewStore.close();
                    }
                    _this.addMenuOpen = false;
                }
                else {
                    _this.addMenuOpen = true;
                }
            }
            onClick();
        };
        _this.handleAddFromLibraryClick = function () {
            _this.addMenuOpen = false;
            _this.props.contentSidebarViewStore.open(TelemetryEnums_1.SidebarOpenOrigin.AddBlockMenu, {
                view: ContentSidebarViewStore_1.SidebarView.Library,
                tab: ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks,
            });
            _this.props.dropzonesStore.setPersistent(_this.props.getCreateBlockButtonIndex(), true);
        };
        _this.handleAddBlockClick = function (block) {
            _this.props.onAddBlock(block);
            _this.addMenuOpen = false;
        };
        _this.randomSuffix = "".concat((0, v1_1.default)());
        _this.onClickOutsideMenu = new utils_1.OnClickOutside([".block-border-".concat(_this.randomSuffix), ".add-block-menu", ".tour-prompt"], function () {
            (0, mobx_1.runInAction)(function () {
                _this.addMenuOpen = false;
            });
        });
        return _this;
    }
    CreateBlockButton.prototype.componentDidMount = function () {
        var _this = this;
        this.disposeReaction = (0, mobx_1.autorun)(function () {
            if (_this.addMenuOpen) {
                _this.onClickOutsideMenu.startListening();
            }
            else {
                _this.onClickOutsideMenu.stopListening();
            }
        });
    };
    CreateBlockButton.prototype.componentWillUnmount = function () {
        this.disposeReaction();
        this.onClickOutsideMenu.stopListening();
    };
    CreateBlockButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, isJustBelowFirstBlock = _a.isJustBelowFirstBlock, disabledCreateOptions = _a.disabledCreateOptions;
        var createBlockButton = (react_1.default.createElement(CreateButton_1.default, { className: (0, classnames_1.default)("create-block-button", { "prompt-target--create-block": isJustBelowFirstBlock }), onClick: this.handleClick }));
        return (react_1.default.createElement("div", { className: "block-border block-border-".concat(this.randomSuffix) },
            react_1.default.createElement("hr", { className: "line", onClick: this.handleClick }),
            react_1.default.createElement("div", null, this.showCloseIcon ? (react_1.default.createElement("div", { className: "close-block-button", onClick: this.handleClick, ref: this.createBlockButtonRef },
                react_1.default.createElement("div", { className: "icon icon-cross" }))) : (createBlockButton)),
            this.addMenuOpen &&
                react_dom_1.default.createPortal(react_1.default.createElement(AddBlockMenuPositioning_1.AddBlockMenuPositioning, { targetRef: this.createBlockButtonRef }, function (_a) {
                    var addBlockMenuRef = _a.addBlockMenuRef, position = _a.position, shouldScrollToPopover = _a.shouldScrollToPopover, zIndex = _a.zIndex;
                    return (react_1.default.createElement(AddBlockMenu_1.AddBlockMenu, { onBlockClick: _this.handleAddBlockClick, onAddFromLibraryClick: _this.handleAddFromLibraryClick, hideAddFromLibrary: _this.isBlockLibraryOpen, blockTypes: _this.availableBlockTypes, innerRef: addBlockMenuRef, disabledCreateOptions: disabledCreateOptions, position: position, shouldScrollToPopover: shouldScrollToPopover, zIndex: zIndex }));
                }), (0, utils_2.getPortalRoot)("addBlockMenu"))));
    };
    Object.defineProperty(CreateBlockButton.prototype, "isDropzoneOpen", {
        get: function () {
            var _a = this.props, dropzonesStore = _a.dropzonesStore, getCreateBlockButtonIndex = _a.getCreateBlockButtonIndex;
            return dropzonesStore.isPersistent && dropzonesStore.currentDropzone.index === getCreateBlockButtonIndex();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateBlockButton.prototype, "isBlockLibraryOpen", {
        get: function () {
            var contentSidebarLibraryViewStore = this.props.contentSidebarLibraryViewStore;
            return (contentSidebarLibraryViewStore.isTabCurrentlyOpen(ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks) &&
                this.props.contentSidebarViewStore.view === ContentSidebarViewStore_1.SidebarView.Library);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateBlockButton.prototype, "showCloseIcon", {
        get: function () {
            return this.addMenuOpen || this.isDropzoneOpen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateBlockButton.prototype, "availableBlockTypes", {
        get: function () {
            if (this.props.hasBlockType(BlockTypes_1.BlockType.OldQuote)) {
                return AddBlockMenu_1.DEFAULT_ADDBLOCKMENU_ITEMS.map(function (bt) { return (bt === BlockTypes_1.BlockType.Quote ? BlockTypes_1.BlockType.OldQuote : bt); });
            }
            return AddBlockMenu_1.DEFAULT_ADDBLOCKMENU_ITEMS;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], CreateBlockButton.prototype, "addMenuOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CreateBlockButton.prototype, "handleClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CreateBlockButton.prototype, "handleAddFromLibraryClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], CreateBlockButton.prototype, "handleAddBlockClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CreateBlockButton.prototype, "isDropzoneOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CreateBlockButton.prototype, "isBlockLibraryOpen", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CreateBlockButton.prototype, "showCloseIcon", null);
    CreateBlockButton = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CreateBlockButton);
    return CreateBlockButton;
}(react_1.default.Component));
exports.CreateBlockButton = CreateBlockButton;
